export const onfidoConfig = {
  workflowId: 'a1d3bda0-7de0-4026-85fe-07076edaabc6',
  
}
